import { useContext, useEffect, useRef } from "react";
import { MdOutlineShoppingCart } from "react-icons/md";
import { LuCalendar } from "react-icons/lu";
import { IoFolderOpenOutline, IoSettingsOutline } from "react-icons/io5";
import { useNavigate, useLocation } from "react-router-dom";
import { DataContext } from "../../lib/contexts";
import css from "./navigationBar.module.css";

interface NavigationBarProps {
  isInputting: boolean;
}

interface NavItem {
  path: string;
  label: string;
  icon: React.ReactNode;
  badge?: number;
}

export function NavigationBar(props: NavigationBarProps) {
  const navigate = useNavigate();
  const location = useLocation();

  const { shoppingList, setCurrentAction } = useContext(DataContext);
  const settingsHoldTimer = useRef<ReturnType<typeof setTimeout>>();
  const suppressSettingsClick = useRef(false);

  useEffect(() => {
    return () => {
      if (settingsHoldTimer.current !== undefined) {
        clearTimeout(settingsHoldTimer.current);
      }
    };
  }, []);

  const navItems: NavItem[] = [
    {
      path: "/shopping-list",
      label: "Indkøb",
      icon: <MdOutlineShoppingCart />,
      badge: (shoppingList?.items || []).length || undefined,
    },
    {
      path: "/week-plan",
      label: "Uge",
      icon: <LuCalendar />,
    },
    {
      path: "/catalogue",
      label: "Retter",
      icon: <IoFolderOpenOutline />,
    },
    {
      path: "/profile",
      label: "Indstillinger",
      icon: <IoSettingsOutline />,
    },
  ];

  function cancelSettingsHold() {
    if (settingsHoldTimer.current !== undefined) {
      clearTimeout(settingsHoldTimer.current);
      settingsHoldTimer.current = undefined;
    }
  }

  return (
    <nav
      className="nav-bar-v2"
      style={{ display: props.isInputting ? "none" : undefined }}
    >
      {navItems.map((item) => {
        const isActive = location.pathname.includes(item.path);
        return (
          <button
            key={item.path}
            aria-label={item.label}
            className={`nav-bar-v2__item ${isActive ? "nav-bar-v2__item--active" : ""}`}
            onClick={() => {
              cancelSettingsHold();

              if (item.path === "/profile" && suppressSettingsClick.current) {
                suppressSettingsClick.current = false;
                return;
              }

              navigate(item.path);
              setCurrentAction(undefined);
            }}
            onPointerDown={(event) => {
              if (
                item.path !== "/profile" ||
                event.button !== 0 ||
                !event.isPrimary
              ) {
                return;
              }

              cancelSettingsHold();
              suppressSettingsClick.current = false;
              settingsHoldTimer.current = setTimeout(() => {
                settingsHoldTimer.current = undefined;
                suppressSettingsClick.current = true;
                navigate("/profile?logs=true");
                setCurrentAction(undefined);
              }, 2000);
            }}
            onPointerUp={cancelSettingsHold}
            onPointerCancel={cancelSettingsHold}
            onPointerLeave={cancelSettingsHold}
            onContextMenu={(event) => {
              if (item.path === "/profile") {
                event.preventDefault();
              }
            }}
          >
            <span className="nav-bar-v2__icon" style={{ position: "relative" }}>
              {item.icon}
              {item.badge != null && (
                <span className={css.badge}>{item.badge}</span>
              )}
            </span>
          </button>
        );
      })}
    </nav>
  );
}
